import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { switchMap } from 'rxjs/operators';
import { UserSettingsService } from './user-setting.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService<T> {
  // Http options
  option = {};

  constructor(
    private _http: HttpClient,
    private _userService: UserSettingsService,
  ) {}

  /**
   * Http Post
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options exmple: { observe: 'response'} to get full response
   */
  public post(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions(options).subscribe(opt => {
      this.option = opt;
    });

    // Http Request
    return this._http.post(endPoint, body, this.option);
  }

  /**
   * Http Post
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options exmple: { observe: 'response'} to get full response
   */
  public patch(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions(options).subscribe(opt => {
      this.option = opt;
    });

    // Http Request
    return this._http.patch(endPoint, body, this.option);
  }

  /**
   * Http Put
   * @param endPoint
   * endpoint to make the request
   * @param body
   * Request body
   * @param options
   * Request options
   */
  public put(endPoint: string, body: T, options?: any): Observable<any> {
    // Loading http options
    this.getOptions().subscribe(opt => {
      this.option = opt;
    });

    // Http Request
    return this._http.put(endPoint, body, this.option);
  }

  /**
   * Http Delete
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options (can include body for DELETE requests)
   */
  public delete(endPoint: string, options?: any): Observable<any> {
    // Loading http options
    return this.getOptions(options).pipe(
      switchMap(opt => {
        this.option = opt;
        const finalOptions: any = { ...this.option };

        // Si hay body en options, usar request() para enviar DELETE con body
        if (options?.body) {
          finalOptions.body = options.body;
          return this._http.request('DELETE', endPoint, finalOptions);
        }

        // Http Request normal sin body
        return this._http.delete(endPoint, finalOptions);
      }),
    );
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public get<Type>(endPoint: string, options?: any): Observable<Type> {
    // Loading http options
    this.getOptions(options).subscribe(opt => {
      this.option = opt;
    });
    let finalEndPoint = endPoint;

    // Http Request
    return this._http.get<Type>(finalEndPoint, this.option);
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public getIp<Type>(endPoint: string): Observable<Type> {
    // Loading http options

    let finalEndPoint = endPoint;

    // Http Request
    return this._http.get<Type>(finalEndPoint);
  }

  /**
   * Http Get
   * @param endPoint
   * endpoint to make the request
   * @param options
   * Request options
   */
  public getNotHeaders<Type>(endPoint: string): Observable<Type> {
    return this._http.get<Type>(endPoint);
  }

  /**
   * Evaluate if the http options were supplied if not, set the global HttpOption
   * @param options
   * Request options
   */
  getOptions(options?: any): Observable<any> {
    let opt = {};

    let token: string = this._userService.getToken();
    // console.log('Token: ', token);
    // Si el token existe
    if (token != null) {
      let headers = new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
      opt = { headers: headers, ...options };
    }

    return of(opt);
  }

  Timeout(refresher?: any) {
    let timeout: any = 20;

    setTimeout(function () {
      if (refresher) {
        refresher.target.complete();
      }
    }, timeout);
  }

  public cancellRefresher(refresher?: any) {
    if (refresher) refresher.target.complete();
  }

  // Cancela el mensaje de 'cargando o el refresher'
  async cancelLoading(refresher?: any) {
    if (refresher) refresher.target.complete();
  }
}
